export default __webpack_public_path__ + "static/media/arrow-below.9aaa4cd3.svg";